import {
  FeatureToggleClient,
  FeatureToggleUser,
} from '@bentley/feature-toggle-js';
import { User } from 'oidc-client';
import { getFeatureToggleConfig } from '../config';

let featureToggleUser: FeatureToggleUser;

const featureToggleClient = new FeatureToggleClient();

export const initializeClient = async (user: User): Promise<void> => {
  featureToggleUser = {
    id: user.profile.sub,
    countryIso: user.profile.usage_country_iso,
    email: user.profile.email ?? '',
    ultimateSite: +user.profile.ultimate_site,
  };
  await featureToggleClient.initializeClient(
    getFeatureToggleConfig().clientSideId,
    featureToggleUser
  );
};

export const getFeatureFlag = (flagName: string): boolean =>
  getFeatureValue<boolean>(flagName, false);

export const getFeatureValue = <T>(flagName: string, defaultValue: T): T => {
  if (!featureToggleUser) {
    console.warn('Uninitialized Launch Darkly client');
    return defaultValue;
  }

  const flag = featureToggleClient.getVariation<T>(flagName, defaultValue);

  return flag;
};
